import BaseInteraction from './BaseInteraction';
import ContentItem from '../api/content/ContentItem';
import logger from '../log';
import { BindOptions } from './interfaces';
import { HLSjsConfigWrapper } from '@kollective-frontend/ksdk-api';
import { SourceType } from '../common/constants';
import { bindHLSjsConfigToWebRTC } from '../webrtc/bindHLSjsToWebRTC';
import { Types, checkType, logUnableToSetupMessage } from '../util/checkTypes';
import attachHlsEvents from './utils/attachHlsEvents';

const log = logger.getLogger(__filename);

export default class HLSjsConfigInteraction extends BaseInteraction<HTMLVideoElement> {
  wrapper: HLSjsConfigWrapper;

  constructor(data: HLSjsConfigWrapper) {
    super(data.element);
    // We don't throw here as that would cascade out and crash the plugin.
    checkType(data, Types.HLSWrapper).emitErrorIfNotCorrectType();
    this.wrapper = data;
  }

  bindInterceptor(
    shouldIntercept: () => boolean,
    getOptions: () => BindOptions
  ): void {
    super.bindInterceptor(shouldIntercept, getOptions);
    // XXX: The following should eventually be moved into the constructor,
    // after confirming that there are no complication based on change of timing.
    const result = checkType(this.wrapper, Types.HLSWrapper);
    if (result.isType) {
      bindHLSjsConfigToWebRTC(this.wrapper, this.binder);
    } else {
      logUnableToSetupMessage(Types.HLSWrapper.name, log, result);
    }
  }

  loader(items: ContentItem[]): ContentItem[] {
    // We don't set source for this interaction (the integrator does).
    return items;
  }

  clearSource(): void {
    // We don't do anything here the integrator handles this.
  }

  videoElement(): HTMLVideoElement {
    return this.player;
  }

  getAllowedSourceTypes(): SourceType[] {
    return [SourceType.HLS];
  }

  addEventListeners(): void {
    super.addEventListeners();
    this.cleanupMethods.push(attachHlsEvents(this.wrapper));
  }
}
